// auth.router.js - Authentication routes
import { requiresNoAuth, resetUser, checkUser } from '../middlewares/auth.validation.js';

export function getAuthRoutes(options = {}) {
  const route = options.route || 'Home';

  // Раскладку экранов входа проект подменяет своей — как community через
  // `settings.layout`. Произвольный конфиг module.manager прокидывает только
  // внутри `settings`, при ручном initialize() опции приходят плоско:
  // поддерживаем оба пути. Фон, шейдер и рамка живут в этом компоненте,
  // поэтому проекту не нужны флаги на каждое оформление.
  const settings = { ...options, ...(options.settings || {}) };
  const layout = settings.layout || (() => import(/* webpackChunkName: "auth-layout" */ '../components/layouts/Auth.vue'));

  return {
    parentName: route,
    config: {
      basePath: 'auth',
      component: layout,
      meta: {
        layoutKey: 'auth',
        // Auth-экран — чистый холст: без хедера/футера/сайдбара приложения.
        // Наследуется всеми дочерними роутами (signin/signup/reset-password).
        header: null,
        footer: null,
        header_navigation: null,
        sidebar_navigation: null,
        sidebar_width_hidden: 'w-zero',
        title: 'auth.title',
      },
      routes: [
        {
          path: 'signin',
          name: 'Sign In',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: 'auth.signIn.title',
          },
          component: () => import(/* webpackChunkName: "signin" */ '../components/pages/SignIn.vue'),
        },
        {
          path: 'reset-password',
          name: 'Reset Password',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: 'auth.resetPassword.title',
          },
          component: () => import(/* webpackChunkName: "reset-password" */ '../components/pages/ResetPassword.vue'),
        },
        {
          path: 'signup',
          name: 'Sign Up',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: 'auth.signUp.title',
          },
          component: () => import(/* webpackChunkName: "signup" */ '../components/pages/SignUp.vue'),
        },
        {
          path: 'invite',
          name: 'Invite',
          beforeEnter: [requiresNoAuth, resetUser],
          meta: {
            title: 'auth.invite.title',
          },
          component: () => import(/* webpackChunkName: "signup" */ '../components/pages/Invite.vue'),
        },
      ],
    }
  };
}
